const ENDPOINT = new Map();

ENDPOINT.set('send', '/exam/question/report/error');

export default ENDPOINT